import { render, staticRenderFns } from "./ministrators.vue?vue&type=template&id=63445672&scoped=true"
import script from "./ministrators.vue?vue&type=script&lang=js"
export * from "./ministrators.vue?vue&type=script&lang=js"
import style0 from "./ministrators.vue?vue&type=style&index=0&id=63445672&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63445672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63445672')) {
      api.createRecord('63445672', component.options)
    } else {
      api.reload('63445672', component.options)
    }
    module.hot.accept("./ministrators.vue?vue&type=template&id=63445672&scoped=true", function () {
      api.rerender('63445672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantAccount/ministrators.vue"
export default component.exports